import script from "./CheckBox.vue?vue&type=script&lang=ts&setup=true"
export * from "./CheckBox.vue?vue&type=script&lang=ts&setup=true"

import "./CheckBox.vue?vue&type=style&index=0&id=36ca912e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36ca912e"]])

export default __exports__